import { SmallSpinner } from './SmallSpinner';

export default SmallSpinner;
